const fonts = {
	ppSansBigRegular: 'pp-sans-big-regular',
	ppSansSmallRegular: 'pp-sans-small-regular',
	ppSansSmallLight: 'pp-sans-small-light'
}

export default fonts;



// WEBPACK FOOTER //
// ./styles/fonts.js